import React from 'react';
import HeroSection from '../components/HeroSection';
import BenefitsSection from '../components/BenefitsSection';
import FeatureSplitSection from '../components/FeatureSplitSection';
import StepsSection from '../components/StepsSection';
import CapabilitiesSection from '../components/CapabilitiesSection';
import FAQSection from '../components/FAQSection';
import CTABlock from '../components/CTABlock';
import ContactStrip from '../components/ContactStrip';
import LegalFooter from '../components/LegalFooter';

const HomePage = () => {
  return (
    <div className="home-page">
      <HeroSection />
      <BenefitsSection />
      <FeatureSplitSection />
      <StepsSection />
      <CapabilitiesSection />
      <FAQSection />
      <CTABlock />
      <ContactStrip />
      <LegalFooter />
    </div>
  );
};

export default HomePage;